import { Component, OnInit, ElementRef, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, MatSnackBarConfig, MatDialog } from '@angular/material';
import { FormControl, Validators, FormGroup, FormBuilder, ValidatorFn, AbstractControl } from '@angular/forms';
import * as $ from 'jquery';
import { TranslateService } from '@ngx-translate/core';
import { ContactService } from '../../../shared/services/contact.service';
import { ContactModel } from "../../../shared/models/contact.model";
import { FailComponent } from '../../../shared/toast/fail/fail.component';

export interface IDialogData {
  objectId: string;
  objectType: string;
  contactId: string;
  mode: string;
  message: string;
  contactCreated: boolean;
  contactEdited: boolean;
  ok: boolean;
}

@Component({
  selector: 'app-contactpopup',
  templateUrl: './contactpopup.component.html',
  styleUrls: ['./contactpopup.component.css']
})
export class ContactpopupComponent implements OnInit {

  genders = [{ code: 'M', name: 'Ông' }, { code: 'F', name: 'Bà' }];
  emptyGuid: string = '00000000-0000-0000-0000-000000000000';
  auth: any = JSON.parse(sessionStorage.getItem("auth"));
  failConfig: MatSnackBarConfig = { panelClass: 'fail-dialog', horizontalPosition: 'end', duration: 5000 };

  createContactForm: FormGroup;
  genderControl: FormControl;
  firstNameControl: FormControl;
  lastNameControl: FormControl;
  emailContactControl: FormControl;
  phoneContactControl: FormControl;
  positionControl: FormControl;

  contactModel = new ContactModel();

  constructor(private translate: TranslateService,
    public snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<ContactpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDialogData,
    public builder: FormBuilder,
    private contactService: ContactService,
    private el: ElementRef) { }

  ngOnInit() {
    this.contactModel.Gender = 'M';
    let emailPattern = '^([" +"]?)+[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]+([" +"]?){2,64}';
    let phonePattern = '^([+]?|0)+[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$';

    this.genderControl = new FormControl('', [Validators.required]);
    this.firstNameControl = new FormControl('', [Validators.required]);
    this.lastNameControl = new FormControl('', [Validators.required]);
    this.positionControl = new FormControl('');
    this.emailContactControl = new FormControl('', [Validators.pattern(emailPattern)]);
    this.phoneContactControl = new FormControl('', [Validators.required, Validators.pattern(phonePattern)]);

    this.createContactForm = new FormGroup({
      genderControl: this.genderControl,
      firstNameControl: this.firstNameControl,
      lastNameControl: this.lastNameControl,
      emailContactControl: this.emailContactControl,
      phoneContactControl: this.phoneContactControl,
      positionControl: this.positionControl
    });

    if (this.data.mode !== 'create') {
      this.contactService.getContactById(this.data.contactId, this.auth.UserId).subscribe(response => {
        var result = <any>response;
        this.contactModel = <ContactModel>(
          {
            ContactId: result.contact.contactId,
            ObjectId: result.contact.objectId,
            ObjectType: result.contact.objectType,
            FirstName: result.contact.firstName,
            LastName: result.contact.lastName,
            Address: result.contact.address,
            AvatarUrl: result.contact.avatarUrl,
            Active: result.contact.active,
            Phone: result.contact.phone,
            Role: result.contact.role,
            Email: result.contact.email,
            SocialUrl: result.contact.socialUrl,
            Gender: result.contact.gender,
            IdentityID: result.contact.identityId,
            CreatedById: result.contact.createdById,
            CreatedDate: result.contact.createdDate,
            UpdatedById: result.contact.updatedById,
            UpdatedDate: result.contact.updatedDate
          });
      }, error => { });
    }
  }

  onSaveClick() {
    this.saveContact();
  }
  onCancelClick() {
    this.dialogRef.close(this.data);
  }

  saveContact() {
    if (!this.createContactForm.valid) {
      Object.keys(this.createContactForm.controls).forEach(key => {
        if (this.createContactForm.controls[key].valid === false) {
          this.createContactForm.controls[key].markAsTouched();
        }
      });

      let target;

      target = this.el.nativeElement.querySelector('.bank-control.form-control.ng-invalid');

      if (target) {
        $('html,body').animate({ scrollTop: $(target).offset().top }, 'slow');
        target.focus();
      }
    } else {
      if (this.data.mode === 'create') {
        this.contactModel.CreatedDate = new Date();
        this.contactModel.CreatedById = this.auth.UserId;
        this.contactModel.ObjectId = this.data.objectId;
        this.contactModel.ObjectType = this.data.objectType;
        this.contactService.createContact(this.contactModel, this.auth.UserId).subscribe(response => {
          var result = <any>response;
          this.data.message = result.messageCode;
          if (result.statusCode === 202 || result.statusCode === 200) {
            this.data.contactCreated = true;
            this.dialogRef.close(this.data);
          } else {
            this.data.contactCreated = false;
            this.snackBar.openFromComponent(FailComponent, { data: result.messageCode, ...this.failConfig });
          }
        },
          error => { });
      } else {
        this.contactService.editContactById(this.contactModel, this.auth.UserId).subscribe(response => {
          var result = <any>response;
          this.data.message = result.messageCode;
          if (result.statusCode === 202 || result.statusCode === 200) {
            this.data.contactCreated = true;
            this.dialogRef.close(this.data);
          } else {
            this.data.contactCreated = false;
            this.snackBar.openFromComponent(FailComponent, { data: result.messageCode, ...this.failConfig });
          }
        },
          error => { });
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/contactpopup/contactpopup.component.ts